export const WHATSAPP_NUMBER = "5524999600620";
export const WHATSAPP_MESSAGE = "Olá! Gostaria de consultar disponibilidade na Casa das Tartarugas.";

export const links = {
  booking: "https://www.booking.com/hotel/br/casa-as-tartarugas.pt-br.html",
  bookingReviews: "https://www.booking.com/reviews/br/hotel/casa-as-tartarugas.pt-br.html",
  google: "https://www.google.com/maps/place/Casa+das+Tartarugas/@-23.0106492,-44.2997156,17z/data=!4m9!3m8!1s0x9c4f0044e15ad3:0xbfa941425bda0513!5m2!4m1!1i2!8m2!3d-23.0106492!4d-44.2971407!16s%2Fg%2F11wbfpvwc5",
  vivaAngra: "https://experiencias.vivaangra.com.br/attractions/1076/casa-das-tartarugas",
  instagram: "https://www.instagram.com/casadastartarugas.angra/",
};

export const navigation = [
  { label: "A Casa", href: "#a-casa" },
  { label: "Acomodações", href: "#acomodacoes" },
  { label: "Experiências", href: "#experiencias" },
  { label: "Localização", href: "#localizacao" },
];

export const amenities = [
  { title: "Café da manhã", text: "Café da manhã servido na propriedade, para começar o dia com calma." },
  { title: "Piscina e áreas externas", text: "Piscina e jardim para aproveitar as pausas entre um passeio e outro." },
  { title: "Conforto", text: "Quartos com ar-condicionado e Wi-Fi para uma estadia tranquila e prática." },
  { title: "Angra ao redor", text: "No bairro Marinas, com acesso à cidade e a tudo o que Angra oferece." },
];

export const testimonials = [
  { quote: "Muito agradável, sensação de aconchego de lar. Tudo muito limpo", author: "Caroline", source: "Booking.com", date: "maio de 2026", href: links.bookingReviews },
  { quote: "Pousada muito charmosa. O destaque são os anfitriões, Marco e Juan.", author: "Leila", source: "Booking.com", date: "março de 2026", href: links.bookingReviews },
  { quote: "A pousada é linda, tudo limpo e organizado", author: "Gianna Miranda", source: "Viva Angra", date: "janeiro de 2026", href: links.vivaAngra },
];
